import { gql } from '@apollo/client';
import {
  CORE_GROUP_FIELDS,
  CORE_INVITATION_FIELDS,
  CORE_MEMBER_FIELDS,
  CORE_PLAYLIST_FIELDS,
} from './fragments';

export const listGroups = gql`
  ${CORE_GROUP_FIELDS}
  query listGroups($pagination: PaginationInput, $filter: GroupFilter) {
    listGroups(pagination: $pagination, filter: $filter) {
      ...CoreGroupFields
    }
  }
`;

export const listInvitations = gql`
  ${CORE_INVITATION_FIELDS}
  query listInvitations($pagination: PaginationInput, $organizationId: ID!) {
    listInvitations(pagination: $pagination, organizationId: $organizationId) {
      ...CoreInvitationFields
    }
  }
`;

export const listMembers = gql`
  ${CORE_MEMBER_FIELDS}
  query listMembers($pagination: PaginationInput, $filter: MemberFilter) {
    listMembers(pagination: $pagination, filter: $filter) {
      ...CoreMemberFields
    }
  }
`;

export const listPlaylists = gql`
  ${CORE_PLAYLIST_FIELDS}
  query listPlaylists($filter: PlaylistFilter, $pagination: PaginationInput) {
    listPlaylists(filter: $filter, pagination: $pagination) {
      ...CoreOrganizationPlaylistFields
    }
  }
`;
